module.exports = __webpack_public_path__ + "img/1550570701.6d21f6ed.jpg";